import AsyncAutocomplete from '@components/v2/form/AsyncAutocomplete/AsyncAutocomplete';
import { Box } from '@mui/material';
import { useState } from 'react';
import { Control, useController } from 'react-hook-form';
import LangEnum from '../../../../lang/LangEnum';
import { CatalogTestIds } from '../../../../utils/testIds/catalog.testIds';
import { useTranslation } from '../../../translation/TranslationContext';
import {
  CatalogCreationAccessAddConfig,
  CatalogCreationAccessEntityOption,
} from '../catalogCreationAccess.types';
import {
  filterListedCatalogCreationAccessOptions,
  resolveCatalogCreationAccessOptionLabel,
} from '../catalogCreationAccess.utils';
import { CatalogCreationAccessAddFormValues } from '../catalogCreationAccessAdd.schema';

interface CatalogCreationAccessAddEntitiesFieldProps {
  control: Control<CatalogCreationAccessAddFormValues>;
  config: CatalogCreationAccessAddConfig;
  selectedOptions: CatalogCreationAccessEntityOption[];
  listedEntityIds: string[];
  onChangeSelectedOptions: (options: CatalogCreationAccessEntityOption[]) => void;
}

const CatalogCreationAccessAddEntitiesField = ({
  control,
  config,
  selectedOptions,
  listedEntityIds,
  onChangeSelectedOptions,
}: CatalogCreationAccessAddEntitiesFieldProps) => {
  const { translate } = useTranslation();
  const { field, fieldState } = useController({ control, name: 'entityIds' });
  const { ref: fieldRef, ...fieldProps } = field;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <Box test-id={CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_ADD_ENTITIES}>
      <AsyncAutocomplete<CatalogCreationAccessEntityOption, true>
        multiple
        ref={fieldRef}
        showAllChips={isDropdownOpen}
        name={fieldProps.name}
        error={!!fieldState.error}
        helperText={fieldState.error?.message}
        value={fieldProps.value}
        initialData={selectedOptions}
        onOpen={() => setIsDropdownOpen(true)}
        onClose={() => setIsDropdownOpen(false)}
        source={config.source}
        label={translate(LangEnum.CATALOGS_BULK_ADD_ENTITIES_SEARCH_LABEL, {
          entity: translate(config.entityLabel),
        })}
        getOptionLabel={(option) =>
          resolveCatalogCreationAccessOptionLabel({ option, labelField: config.labelField })
        }
        formatOptions={(options) =>
          filterListedCatalogCreationAccessOptions({ options, listedEntityIds })
        }
        onChange={(entityIds, options) => {
          fieldProps.onChange(entityIds);
          onChangeSelectedOptions(options);
        }}
      />
    </Box>
  );
};

export default CatalogCreationAccessAddEntitiesField;
